export const BLACK_BOX_SUPPORTED_QUALIFICATIONS: {
  [key: string]: BlackBoxQualificationValue;
} = {
  211: {
    key: 'gender',
    type: 'singlepunch',
    default: 'Any',
  },
  212: {
    key: 'age_grp',
    type: 'range',
    default: 'Any',
  },
  244: {
    key: 'race',
    type: 'singlepunch',
    default: 'Any',
  },
  245: {
    key: 'hispanic_origin',
    type: 'singlepunch',
    default: 'No',
  },
};

interface BlackBoxQualificationValue {
  key: string;
  type: string;
  default: string;
}

export interface BlackBoxPayloadInterface {
  [key: string]: string;
}
